/**
 * @description 布局
 * @date 2023-10-30 15:23:23
 * @author 2028
 */
export default {
  namespaced: true,
  state: {
    isShowSetting: false, // 是否显示设置弹出框
  },
  mutations: {
    setIsShowSetting(state, flag) {
      state.isShowSetting = flag
    },
  },
  actions: {}
}
